import React from 'react';
import { Menu, Icon } from 'semantic-ui-react';

interface TablePaginationMenuProps {
  currentPage: number; // Current page number
  dataCount: number;       // Total number of items
  setCurrentPage: (page: number) => void; // Function to update the current page
}

const TablePaginationMenu: React.FC<TablePaginationMenuProps> = ({ currentPage, dataCount, setCurrentPage }) => {
  const lastPage = Math.ceil(dataCount / 10);
  return (
    <Menu floated="right" pagination>
      <Menu.Item>
        <p>{`${currentPage * 10 - 9} - ${
          dataCount < currentPage * 10 ? dataCount : currentPage * 10
        } de ${dataCount}`}</p>
      </Menu.Item>
      <Menu.Item
        disabled={currentPage === 1}
        as="a"
        icon
        onClick={() => setCurrentPage(1)}
      >
        <Icon name="angle double left" />
      </Menu.Item>
      <Menu.Item
        disabled={currentPage === 1}
        as="a"
        icon
        onClick={() => setCurrentPage(currentPage - 1)}
      >
        <Icon name="chevron left" />
      </Menu.Item>
      <Menu.Item>{currentPage}</Menu.Item>
      <Menu.Item
        disabled={currentPage === lastPage || dataCount <= 10}
        as="a"
        icon
        onClick={() => setCurrentPage(currentPage + 1)}
      >
        <Icon name="chevron right" />
      </Menu.Item>
      <Menu.Item
        disabled={currentPage === lastPage || dataCount <= 10}
        as="a"
        icon
        onClick={() => setCurrentPage(lastPage)}
      >
        <Icon name="angle double right" />
      </Menu.Item>
    </Menu>
  );
};

export default TablePaginationMenu;
